import { render } from "./NotFoundView.vue?vue&type=template&id=57f2c26a&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=57f2c26a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f2c26a"]])

export default __exports__